<template>
  <div class="wizard-body small-9 columns container-center">
    <div class="qr-container">
      <div
        v-if="displayRefreshOverlay"
        class="qr-overlay"
        @click="refreshQrCode"
      >
        <div class="overlay-content">
          <fluent-icon
            size="32"
            viewbox="0 0 33 32"
            icon="replay"
            class="refresh-icon"
            type="solid"
          />
          <p class="refresh-text">
            {{ $t('INBOX_MGMT.ADD.EVOLUTION_API.QR_REFRESH_TEXT') }}
          </p>
        </div>
      </div>
      <img
        :src="fields.qrCode"
        alt="QR Code"
        class="qr-code"
        :class="{ 'qr-code-faded': displayRefreshOverlay }"
      />
    </div>
    <h2 class="link-number">
      {{ $t('INBOX_MGMT.ADD.EVOLUTION_API.LINK_NUMBER_STEP.TITLE') }}
    </h2>
    <div class="instructions">
      <p>
        {{ $t('INBOX_MGMT.ADD.EVOLUTION_API.LINK_NUMBER_STEP.DESCRIPTION') }}
      </p>
      <ol>
        <li>
          {{
            $t(
              'INBOX_MGMT.ADD.EVOLUTION_API.LINK_NUMBER_STEP.INSTRUCTIONS.STEP_1'
            )
          }}
        </li>
        <li>
          {{
            $t(
              'INBOX_MGMT.ADD.EVOLUTION_API.LINK_NUMBER_STEP.INSTRUCTIONS.STEP_2.PART_1'
            )
          }}
          <fluent-icon
            width="24"
            height="32"
            viewbox="0 0 24 32"
            icon="settings-android"
            type="solid"
            class="icon-android"
          />
          {{
            $t(
              'INBOX_MGMT.ADD.EVOLUTION_API.LINK_NUMBER_STEP.INSTRUCTIONS.STEP_2.PART_2'
            )
          }}
          <img
            :src="'/assets/images/conversa2/settings_iphone.png'"
            class="icon-ios"
          />
          {{
            $t(
              'INBOX_MGMT.ADD.EVOLUTION_API.LINK_NUMBER_STEP.INSTRUCTIONS.STEP_2.PART_3'
            )
          }}
        </li>

        <li>
          {{
            $t(
              'INBOX_MGMT.ADD.EVOLUTION_API.LINK_NUMBER_STEP.INSTRUCTIONS.STEP_3'
            )
          }}
        </li>
        <li>
          {{
            $t(
              'INBOX_MGMT.ADD.EVOLUTION_API.LINK_NUMBER_STEP.INSTRUCTIONS.STEP_4'
            )
          }}
        </li>
      </ol>
      <a
        :href="
          $t('INBOX_MGMT.ADD.EVOLUTION_API.LINK_NUMBER_STEP.HELP_LINK.URL')
        "
        target="_blank"
        class="help-link"
      >
        {{ $t('INBOX_MGMT.ADD.EVOLUTION_API.LINK_NUMBER_STEP.HELP_LINK.TEXT') }}
      </a>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import router from '../../../../../index';
import alertMixin from 'shared/mixins/alertMixin';

export default {
  name: 'WhatsAppLink',
  mixins: [alertMixin],
  data() {
    return {
      provider: 'evolution_api',
      title: 'WhatsApp vinculado',
      fields: {},
      displayRefreshOverlay: false,
      isRefreshing: false,
    };
  },
  computed: {
    // Mapea el estado global de 'inboxes' y accede a 'EVOLUTION_API_CONNECT'
    ...mapState('inboxes', ['EVOLUTION_API_CONNECT']),
  },
  watch: {
    // Maneja eventos de conexión de Evolution API
    async EVOLUTION_API_CONNECT(data) {
      // para que solo se ejecute si esta en el 4to paso del wizard, sin esta validación se ejecuta cada vez que se vincula el numero incluso en la vista del editar
      if (this.$route.name === 'settings_inbox_link_number') {
        if (
          data.event === 'connected' &&
          data.instance === this.fields.phoneNumber
        ) {
          // Redirige a la página de configuración de agentes cuando la conexión es exitosa
          this.displayRefreshOverlay = false;
          this.fields.linked = true;
          try {
            // si el número se vinculó correctamente se actualiza el valor en el state y la BD
            await this.updateLinkedNumberStatus();
          } catch (error) {
            console.error(error);
          }
          router.replace({
            name: 'settings_inboxes_add_agents',
            params: { page: 'new', inbox_id: this.fields.inbox.id },
          });
        }
        // Muestra una alerta de error si los números no coinciden
        else if (
          data.event === 'different_numbers' &&
          data.instance === this.fields.phoneNumber
        ) {
          this.showAlertError(
            this.$t('INBOX_MGMT.ADD.EVOLUTION_API.ERRORS.DIFFERENT_NUMBERS')
          );
          this.displayRefreshOverlay = true;
        } else if (
          data.event === 'qrcode_refused' &&
          data.instance === this.fields.phoneNumber
        ) {
          this.displayRefreshOverlay = true;
        } else if (
          data.event === 'qrcode_updated' &&
          data.instance === this.fields.phoneNumber &&
          data.data?.base64
        ) {
          this.displayRefreshOverlay = false;
          this.fields.qrCode = data.data.base64;
        } else {
          this.displayRefreshOverlay = true;
        }
      }
    },
  },
  mounted() {
    this.fields = this.$route.params.fields;
  },
  methods: {
    // Mapea la acción `evolutionApiConnect` del módulo `inboxes` para su uso en el componente
    ...mapActions('inboxes', ['evolutionApiConnect']),
    // Construye los parámetros del canal para refrescar el qr de la bandeja de entrada de Evolution API
    channelParams() {
      return {
        allow_send_messages: this.fields.allowSendMessages,
        inbox_name: this.fields.inboxName,
        phone_number: this.fields.phoneNumber,
        name: this.fields.inboxName,
        channel: {
          phone_number: this.fields.phoneNumber,
          type: 'evolutionapi',
        },
      };
    },
    // Metodo para refrescar el codigo QR
    async refreshQrCode() {
      // Evita múltiples clics mientras se está refrescando
      if (this.isRefreshing) return;

      this.isRefreshing = true;

      // Llama a la acción Vuex para actualizar el código QR
      await this.$store
        .dispatch('inboxes/connectEvolutionInstance', this.channelParams())
        .then(data => {})
        .catch(error => {
          this.showAlertError(
            this.$t('INBOX_MGMT.ADD.EVOLUTION_API.ERRORS.QR_REFRESH_ERROR')
          );
        })
        .finally(() => {
          this.isRefreshing = false;
        });
    },
    // Actualiza el valor del atributo linked en el state y la BD
    async updateLinkedNumberStatus() {
      try {
        const payload = {
          id: this.fields.inbox.id,
          linked: this.fields.linked,
        };
        await this.$store.dispatch('inboxes/updateInbox', payload);
      } catch (error) {
        console.error(error.message);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.wizard-body {
  justify-content: center;
}

.container-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.qr-container {
  position: relative;
  max-width: 400px;
  background: #fff;
}

.qr-code {
  width: 264px;
  height: 264px;
  background: black;
}

.qr-code-faded {
  opacity: 0.06;
}

.qr-overlay {
  top: 50%; /* Center vertically */
  left: 50%; /* Center horizontally */
  transform: translate(
    -50%,
    -50%
  ); /* Shift the element back by half its width and height */
  position: absolute;
  width: 190px;
  height: 190px;
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #000000;
  z-index: 20;
  cursor: pointer; /* Cambia el cursor para indicar que es clickable */
}

.overlay-content {
  text-align: center;
}

.refresh-icon {
  color: white;
  margin-bottom: var(--space-one);
}

.refresh-text {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: center;
  color: #ffffff;
}

.link-number h2 {
  font-weight: var(--font-weight-normal);
  font-size: 32px;
  line-height: 40px;
  letter-spacing: 0px;
  text-align: center;
}

.instructions {
  border-width: 1px;
  padding: var(--space-two);
  border: 1px solid var(--conversa2-neutral-100-color);
}

.instructions p {
  font-weight: var(--font-weight-normal);
  font-size: 20px;
  line-height: 28px;
  letter-spacing: 0px;
}

.instructions ol {
  margin-left: 2.25rem;
}

.instructions li {
  padding: var(--space-small);
  font-weight: var(--font-weight-normal);
  font-size: 2rem;
  line-height: 2.8rem;
  letter-spacing: 0px;
}

.icon {
  font-weight: bold;
}

.help-link {
  font-weight: var(--font-weight-normal);
  font-size: 2rem;
  line-height: 2.8rem;
  letter-spacing: 0px;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-offset: Auto;
  text-decoration-thickness: Auto;
  color: var(--conversa2-blue-700-color);
}

.link-number {
  font-weight: var(--font-weight-normal);
  font-size: 3.2rem;
  line-height: 4rem;
  letter-spacing: 0px;
  text-align: center;
  padding-top: var(--space-two);
  padding-bottom: var(--space-two);
}
.icon-android {
  border-radius: var(--border-radius-normal-small);
  border-width: 1px;
  background: var(--conversa2-neutral-50-color);
  border: 1px solid var(--conversa2-neutral-300-color);
  vertical-align: middle;
}

.icon-ios {
  width: 32px;
  height: 32px;
  border-radius: var(--border-radius-normal-plus);
  vertical-align: middle;
}
</style>
